import React, { forwardRef, HtmlHTMLAttributes, memo, ReactNode, useMemo } from "react";
import classNames from "classnames";
import { getInitials } from "./utils";

import { ReactComponent as PlaceholderImage } from "./images/placeholder.svg";

import styles from "./styles.module.scss";

export type AvatarSize = "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl" | "xxxxl";

export type AvatarPropsType = HtmlHTMLAttributes<HTMLDivElement> & {
  placeholderBlockClassName?: string
  userName?: string
  avatarSize?: AvatarSize
  statusIcon?: ReactNode
  avatarIcon?: string
}

export const Avatar = memo(forwardRef<HTMLDivElement, AvatarPropsType>((
  {
    avatarSize = "md",
    statusIcon,
    className,
    avatarIcon,
    userName,
    placeholderBlockClassName,
    ...props
  }, ref) => {
  const initials = useMemo(() => getInitials(userName), [ userName ]);

  return (
    <div
      data-avatar-size={avatarSize}
      {...props}
      ref={ref}
      style={{
        backgroundImage: `url(${avatarIcon})`,
        ...props?.style,
      }}
      className={classNames(
        className,
        styles.root,
        styles[avatarSize as keyof typeof styles],
      )}
    >
      <div className={classNames(styles.placeholderBlock, placeholderBlockClassName)}>
        {initials ? <span>{initials}</span> : <PlaceholderImage />}
      </div>
      {statusIcon && <div className={styles.statusIcon}>{statusIcon}</div>}
    </div>
  );
}));
